export const MAX_EMAIL_LENGTH = 50;
export const MAX_BIO_LENGTH = 300;
export const MAX_USERNAME_LENGTH = 30;
